import React, { useEffect, useRef, useState } from "react";
import Header from "../components/home/header";
import Interview from "../components/interview/interview";
import { useInterview } from "../contexts/interview.context";
import { useLocation, useNavigate } from "react-router-dom";
import { GoogleAd } from "../components/ads/GoogleAd";
import { useScreen } from "../contexts/screen.provider";
declare global {
  interface Window {
    SpeechRecognition: any;
    webkitSpeechRecognition: any;
    SpeechGrammarList: any;
    webkitSpeechGrammarList: any;
    webkitAudioContext: any
  }
}


export { };

function Home() {
  const { isTablet, isDesktop } = useScreen()
  const navigate = useNavigate();

  const { resetInterview } = useInterview()
  const [displaySidebar, setDisplaySidebar] = useState(false);
  function changeSidebarDisplay() {
    setDisplaySidebar((prev) => !prev);
  }
  const location = useLocation();
  const interviewRef = useRef<HTMLDivElement | null>(null)

  // useEffect(() => {
  //   if (isOnline && toastId) {
  //     toast.dismiss(toastId);
  //     toast.success("Back online. Retrying request...", {
  //       autoClose: 3000,
  //     });
  //     setToastId(null);
  //     updateInterview({ isOnline: true })
  //   } else {
  //     if (!isOnline && !toastId) {
  //       updateInterview({ isOnline: false })
  //       setToastId(
  //         toast.info("You are offline. Waiting for connection to retry...", {
  //           autoClose: false,
  //         })
  //       );
  //     }
  //   }
  // }, [isOnline]);
  React.useEffect(() => {
    if (location.pathname !== "/current-interview") return;

    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      e.returnValue = ""; // Shows confirmation on most browsers
    };

    const handlePopState = () => {
      const confirmExit = window.confirm("Are you sure you want to cancel the interview?");
      if (!confirmExit) {
        navigate(0); // Revert back
      }
    };

    const handleUnload = () => {
      sessionStorage.removeItem("LISTENING");
      // Reset interview or clean up state here
      resetInterview();
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    window.addEventListener("popstate", handlePopState);
    window.addEventListener("unload", handleUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.removeEventListener("popstate", handlePopState);
      window.removeEventListener("unload", handleUnload);
    };
  }, [location.pathname, navigate]);
  useEffect(() => {
    const el = interviewRef.current;
    if (!el) return;

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "style"
        ) {

          el.removeAttribute("style");
          el.classList.add("force-full-height", "overflow-hidden", "min-h-100-vh-safe", "max-h-100-vh-safe", "h-100-vh-safe", "py-1");

        }
      }
    });

    observer.observe(el, {
      attributes: true,
      attributeFilter: ["style"],
    });

    // Clean up when component unmounts
    return () => observer.disconnect();
  }, []);


  return (
    <div ref={interviewRef} className="w-full force-full-height   min-h-100-vh-safe  max-h-100-vh-safe h-100-vh-safe py-1  bg-white dark:bg-[#202020] flex flex-col">
      <Header isFixed={false} isAdsVisible={true} withMenuIcon={false} sidebarDisplay={displaySidebar} changeSidebarDisplay={changeSidebarDisplay} />
      <main className="flex h-92-vh-safe justify-stretch tablet:justify-center  items-end tablet:items-stretch  flex-1 max-h-92-vh-safe overflow-hidden flex-col tablet:flex-row flex-grow ">

        {/* <GoogleAd className="ad-container-interview" /> */}
        {isTablet && <div className="flex-[100px] w-full " >
          <GoogleAd />
        </div>}
        {
          isDesktop && <GoogleAd />
        }
        <Interview />
        {isDesktop &&
          <GoogleAd />
        }

      </main>
    </div>

  );
}

export default Home;
